// extracted by mini-css-extract-plugin
module.exports = {"list-bottom":"UserMenu_list-bottom__mWrMT","btn-user":"UserMenu_btn-user__c8603","userName":"UserMenu_userName__jKQFK"};